import { Section } from "./style";

export default function Copyright() {
  return (
    <Section>
      © 2024 K&K Turismo. Todos os direitos reservados. Feito por:{" "}
      <a href="https://www.tensortech.com.br/" target="_blank" rel="noreferrer">
        Tensortech
      </a>
    </Section>
  );
}
